import db from '../../data/db';

const { useState, useEffect } = wp.element;

/**
 * Fetches the last updated date from the database.
 *
 * @param { string }   countryCode    - The country code for the settings table.
 * @param { Function } setLastUpdated - The state setter function for last updated date.
 */
const fetchLastUpdated = async ( countryCode, setLastUpdated ) => {
	const dbLastUpdated = await db.table( `${ countryCode }_settings` ).get( 'lastUpdated' );
	if ( dbLastUpdated ) {
		const date = new Date( dbLastUpdated.value );
		const DateFormatOptions = {
			year: 'numeric', month: 'long', day: 'numeric',
			hour: '2-digit', minute: '2-digit',
		};
		const formattedDate = date.toLocaleString( AcProductLookupBlock.jsLocale ?? 'sv-SE', DateFormatOptions );
		setLastUpdated( formattedDate );
	}
};

/**
 * Renders the introduction section displaying the last database update.
 *
 * @param { string } countryCode - String containing block defined country.
 *
 * @return { JSX.Element } Rendered introduction section.
 */
export default function Intro( { countryCode } ) {
	const [ lastUpdated, setLastUpdated ] = useState( '' );

	useEffect( () => {
		fetchLastUpdated( countryCode, setLastUpdated );
	}, [] );

	return (
		<div className="product-lookup__intro" >
			{ window.wp.i18n.__( 'Last updated:', 'ac-product-lookup' ) } { lastUpdated }
		</div>
	);
}
